import React from 'react'

import { useStyles } from './JobShowBannerMobileSticky_style'
import { Box } from '@material-ui/core'

import ApplyButton from '../../../ApplyButton/ApplyButton'
import FavoriteAction from 'components/FavoriteAction/FavoriteAction'

const JobShowBannerMobileSticky = (props) => {
    const { user, job, unavailable } = props
    const classes = useStyles()

    return (
        <Box className={classes.stickyBannerContainer}>
            <Box className={classes.rightContainer}>
                {!unavailable && <>
                    <FavoriteAction
                        userType={user?.type}
                        type={job.type}
                        id={job.id}
                        item={job}
                        size='30px'
                        padding='0px'
                    />
                    <ApplyButton
                        containerClass={classes.applyButtonContainer}
                        buttonsClass={classes.applyButton}
                        job={job}
                        user={user}
                        buttonSize='small'
                    />
                </>}
            </Box>
        </Box>
    )
}

export default JobShowBannerMobileSticky
